module.exports = __webpack_public_path__ + "img/sharelink.13b28a44.svg";